<template>

    <nav id="menuMeans" v-if="$route.path === '/keinot'" :class="$mq">

      <ul v-if="isCategoryMenu" class="meanCategoryHeaders">
        <p class="mb-2 font-6-5 txt-bold txt-upper noselect">KATEGORIAT:</p>
        <p class="color-grey txt-bold mb-1" style="letter-spacing: 0.04rem;">TILA</p>
        <p class="absolute color-grey txt-bold" style="top: 210px;">TAUSTATEKIJÄT</p>
        <!-- <li @click="setCategory(null)">kaikki</li> -->
        <li
          v-for="(category,index) in sortedCategories"
          :key="index"
          @click="setCategory(category)"
          :class="setClass(category.class)"
          class="noselect pointer"
        >
          <i class="material-icons">{{ category.icon }}</i>
          <span>{{ category.title }}</span>
        </li>
      </ul>

      <div @click="setCategoryMenu" class="trigger">
        <i v-if="!isCategoryMenu" class="material-icons">chevron_right</i>
        <i v-else class="material-icons">chevron_left</i>
      </div>

    </nav>

</template>

<script>
// import db from '@/firebase/init'
import { mapState } from 'vuex'

export default {
  name: 'menuMeans',

  data () {
    return {
      // categories: [],
      selectedCategory: null,
      highlighted: null
    }
  },

  created () {
    this.$store.dispatch('storeCategories')
  },

  computed: {
    ...mapState([
      'isCategoryMenu',
      'isCategory'
      // 'vuexCategories'
    ]),

    sortedCategories () {
      let temp = this.$store.state.categories.slice()
      temp.sort(this.compareValues('class'))
      return temp
    }
  },

  methods: {
    /* getCategories () {
      db.collection('kategoriat').get().then(snapshot => {
        snapshot.docs.forEach(doc => {
          let category = doc.data()
          this.categories.push(category)
        })
      })
    }, */

    // dynamic sorting function:
    compareValues (key, order = 'asc') {
      return function (a, b) {
        if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) { // property doesn't exist on either object
          return 0
        }

        const varA = (typeof a[key] === 'string') ? a[key].toUpperCase() : a[key]
        const varB = (typeof b[key] === 'string') ? b[key].toUpperCase() : b[key]

        let comparison = 0
        if (varA > varB) {
          comparison = 1
        } else if (varA < varB) {
          comparison = -1
        }
        return (
          (order === 'desc') ? (comparison * -1) : comparison
        )
      }
    },

    setClass (category) {
      return {
        ['group-' + category]: true,
        highlighted: this.highlighted === category
      }
    },

    setCategory (data) {
      if (this.isCategory === data) {
        this.$store.dispatch('setCategory', null)
      } else {
        this.$store.dispatch('setCategory', data)
      }
      if (this.highlighted === null || this.highlighted !== data.class) {
        this.highlighted = data.class
      } else {
        this.highlighted = null
      }
    },

    setCategoryMenu () {
      if (this.isCategoryMenu === true) {
        this.$store.dispatch('setCategoryMenu', false)
      } else {
        this.$store.dispatch('setCategoryMenu', true)
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/styles/styles.scss";

#menuMeans { //nav
  position: fixed;
  top: $Tbar-height;
  left: 0;
  height: calc(100vh - #{$Tbar-height});
  width: 0;
  &.phone {
    li span { display: none; }
  }
  & > span {
    position: absolute;
    left: -12px;
    top: 100px;
    transform: rotate(-90deg);
    transform-origin: center center;
    font-size: 0.85rem;
  }
  ul {
    position: relative;
    top: 0;
    left: 0;
    width: $category-menu-width;
    padding: 15px 0 0 15px;
    li {
      position: relative;
      width: $category-menu-button;
      height: $category-menu-button;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 6px;
      border-radius: 50%;
      background-color: color(hl2);
      box-shadow: 1px 1.5px 2px rgba(0, 0, 0, 0.2);
      font-size: 0.6rem;
      opacity: 0.95;
      &:nth-of-type(3) {
        margin-bottom: 32px;
        white-space: nowrap;
      }
      &:hover {
        opacity: 1;
        font-weight: bold;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
      }
      &:nth-of-type(1) {
        width: calc(#{$category-menu-button} * 1.25);
        height: calc(#{$category-menu-button} * 1.25);
        i { transform: scale(1.3, 1.3); }
      }
      /* &:nth-child(-n+3) {
        background-color: color(ui-main);
      } */
      &.highlighted {
        //background-color: rgb(255, 51, 0);
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
        span { font-weight: bold; }
      }
      i {
        color: white;
      }
      span {
        position: absolute;
        left: calc(100% + 8px);
        top: 50%;
        transform: translateY(-50%);
        font-size: 0.75rem;
      }
    }
  }
  .trigger i {
    position: absolute;
    /* bottom: 10px; */
    top: calc((#{$category-menu-button} + 19px) * 8);
    left: 5px;
    font-size: 20px !important;
    color: grey;
  }
}
.meanCategoryHeaders p {
  font-size: 0.8rem;
  .phone & {
    font-size: 0.55rem;
  }
}
</style>
